(function (window, $, calendarConfiguration) {
    function ApiClient(configuration) {
        this.configuration = configuration;

        this.baseUrl = configuration.apiHostName;
    }

    ApiClient.prototype._constructUrl = function () {
        return this.baseUrl + '/' + Array.prototype.join.call(arguments, '/');
    };

    /**
     * @returns {string} The API url for text templates.
     */
    ApiClient.prototype._getTextTemplateUrl = function () {
        var argumentsArray = ['user', this.configuration.calendarOwnerId, 'texttemplate'];
        if (arguments && arguments.length) {
            for (var k in arguments) {
                if (arguments.hasOwnProperty(k)) {
                    argumentsArray.push(arguments[k]);
                }
            }
        }
        return this._constructUrl.apply(this, argumentsArray);
    };

    /**
     * @returns {string} The API url for comment.
     */
    ApiClient.prototype._getCommentUrl = function () {
        var argumentsArray = ['user', this.configuration.calendarOwnerId, 'appointment', currentEvent.appointmentId, 'occurrence', currentEvent.id, 'comment'];
        if (arguments && arguments.length) {
            for (var k in arguments) {
                if (arguments.hasOwnProperty(k)) {
                    argumentsArray.push(arguments[k]);
                }
            }
        }
        return this._constructUrl.apply(this, argumentsArray);
    };

    ApiClient.prototype._executeRequest = function (url, type, async, data) {
        var requestUrl = url;

        var requestOptions = {
            headers: {
                'Access-Control-Allow-Origin': this.baseUrl
            },
            xhrFields: {
                withCredentials: true
            },
            url: requestUrl,
            type: type,
            dataType: "json",
            contentType: 'application/json; charset=utf-8',
            async: async || false,
            timeout: 10000
        };

        if (type === 'GET' && typeof data !== 'undefined' && data) {
            var _data = typeof data === "string" ? data : $.param(data);
            requestOptions.url = requestUrl + '?' + _data;
        } else if (type === 'POST' || type === 'PUT') {
            requestOptions.data = JSON.stringify(data);
        }

        return $.ajax(requestOptions);
    };

    ApiClient.prototype.getActiveMultiCard = function () {
        return this._executeRequest(this._constructUrl("user/"
            + calendarConfiguration.loginUserId
            + "/multicard/active/"
            + calendarConfiguration.calendarOwnerId), "GET", true);
    };

    ApiClient.prototype.getActivePrepaidCard = function () {
        return this._executeRequest(this._constructUrl("user/"
            + calendarConfiguration.loginUserId
            + "/prepaid/"
            + calendarConfiguration.calendarOwnerId
            + "/balance"), "GET", true);
    };

    ApiClient.prototype.getContactList = function (clubId) {
        var url = clubId ? this._constructUrl('contacts', clubId) : this._constructUrl('contacts');

        return this._executeRequest(url, 'GET', true);
    };

    ApiClient.prototype.getTranslations = function (culture, key) {
        return this._executeRequest(this._constructUrl('translation'), 'GET', false, "culture=" + culture + "&keys=" + encodeURIComponent(key));
    };

    ApiClient.prototype.cancelAppointment = function (appointmentId) {
        return this._executeRequest(this._constructUrl('appointment',
            this.configuration.calendarOwnerId,
            appointmentId),
            'DELETE',
            true);
    };

    ApiClient.prototype.getAppointmentTemplates = function (proId, async) {
        return this._executeRequest(this._constructUrl('templates', proId),
            'GET',
            !!async);
    }

    /**
     * @returns {promise} A promise to the request result for all text templates.
     */
    ApiClient.prototype.getTextTemplates = function () {
        return this._executeRequest(this._getTextTemplateUrl(),
            'GET',
            true);
    };

    /**
     * @param {string} id The text template identifier.
     * @returns {promise} A promise to the request result for a specific text template.
     */
    ApiClient.prototype.getTextTemplate = function (id) {
        return this._executeRequest(this._getTextTemplateUrl(id),
            'GET',
            true);
    };

    /**
     * @param {any} data The text template to create.
     * @returns {promise} A promise to the request result for creating a text template.
     */
    ApiClient.prototype.createTextTemplate = function (data) {
        return this._executeRequest(this._getTextTemplateUrl(),
            'PUT',
            true,
            data);
    };

    /**
     * @param {string} id The text template identifier.
     * @param {any} data The text template to update.
     * @returns {promise} A promise to the request result for updating a text template.
     */
    ApiClient.prototype.updateTextTemplate = function (id, data) {
        return this._executeRequest(this._getTextTemplateUrl(id),
            'POST',
            true,
            data);
    };

    /**
     * @param {string} id The text template identifier.
     * @returns {promise} A promise to the request result for deleting a text template.
     */
    ApiClient.prototype.deleteTextTemplate = function (id) {
        return this._executeRequest(this._getTextTemplateUrl(id),
            'DELETE',
            true);
    };
    //-------------------------------------------------------------------------------
    /**
     * @returns {promise} A promise to the request result for all appointment discussion(comments).
     */
    ApiClient.prototype.getComments = function () {
        return this._executeRequest(this._getCommentUrl(),
            'GET',
            true);
    };

    /**
     * @param {string} id The comment identifier.
     * @returns {promise} A promise to the request result for a specific comment.
     */
    ApiClient.prototype.getComment = function (id) {
        return this._executeRequest(this._getCommentUrl(id),
            'GET',
            true);
    };

    /**
     * @param {any} data The comment to create.
     * @returns {promise} A promise to the request result for creating a comment.
     */
    ApiClient.prototype.createComment = function (data) {
        return this._executeRequest(this._getCommentUrl(),
            'POST',
            true,
            data);
    };

    /**
     * @param {string} id The comment identifier.
     * @param {any} data The comment to update.
     * @returns {promise} A promise to the request result for updating a comment.
     */
    ApiClient.prototype.updateComment = function (id, data) {
        return this._executeRequest(this._getCommentUrl(id),
            'PUT',
            true,
            data);
    };

    /**
     * @param {string} id The comment identifier.
     * @returns {promise} A promise to the request result for deleting a comment.
     */
    ApiClient.prototype.deleteComment = function (id) {
        return this._executeRequest(this._getCommentUrl(id),
            'DELETE',
            true);
    };

    /**
     * @returns {promise} A promise to the request result for the API version.
     */
    ApiClient.prototype.getApiVersion = function () {
        return this._executeRequest(this._constructUrl('version'), 'GET', true);
    };

    /**
     * @returns {promise} A promise to the request result for the new iCal link.
     */
    ApiClient.prototype.regenerateICalLink = function () {
        return this._executeRequest(this._constructUrl('export', 'regenerateICalLink'), 'GET', true);
    };

    ApiClient.prototype.isFlatrateValidForOccurrence = function (occurrence) {
        if (!occurrence.isFlatrate) {
            return Promise.resolve({data: false, error: null});
        }

        return this._executeRequest(
            this._constructUrl('user', calendarConfiguration.loginUserId, 'flatrate', 'checkValid'),
            'GET',
            true,
            {
                trainerId: calendarConfiguration.calendarOwnerId,
                start: occurrence.start.toISOString(),
                end: occurrence.end.toISOString()
            });
    };

    ApiClient.prototype.getResources = function () {
        return this._executeRequest(this._constructUrl('resources'), 'GET', true);
    };

    ApiClient.prototype.loadAcademyProList = function (clubId) {
        return this._executeRequest(this._constructUrl("academy", calendarConfiguration.calendarOwnerId, "trainers") + (!!clubId ? ("?clubId=" + clubId) : ""), "GET", true);
    };

    ApiClient.prototype.loadAvailableAppliances = function (locationId, calendarOwnerId, start, end, isAddon) {
        if (!locationId) throw "Location ID is missing";
        if (!calendarOwnerId) throw "Calendar Owner ID is missing";
        if (!start) throw "Start is missing";
        if (typeof start.format !== "function") throw "start.toISOString is missing - bad object type?";
        if (!end) throw "End is missing";
        if (typeof end.format !== "function") throw "end.toISOString is missing - bad object type?";

        // Because it just happened: https://www.youtube.com/watch?v=-5wpm-gesOY
        start = start.format("YYYY-MM-DD") + "T" + start.format("HH:mm");
        end = end.format("YYYY-MM-DD") + "T" + end.format("HH:mm");

        return this._executeRequest(
            this._constructUrl("appliances", locationId, calendarOwnerId) + "?start=" + encodeURIComponent(start) + "&end=" + encodeURIComponent(end) + "&isAddon=" + isAddon,
            "GET",
            true
        );
    }

    /**
     * Retrieves the current user's account balance with the current calendar owner.
     */
    ApiClient.prototype.getAccountBalance = function () {
        return this._executeRequest(this._constructUrl('user', calendarConfiguration.loginUserId, 'prepaid', calendarConfiguration.calendarOwnerId, 'balance'), 'get', true);
    }

    window.ApiClient = new ApiClient(calendarConfiguration);
})(window, $, window.calendarConfiguration);
